import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseAPIService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { IGarbageCollectorStatistic } from '../interfaces/garbage-collector-statistic.interface';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class APIInstanceService extends BaseAPIService {
    constructor(private readonly http: HttpClient) {
        super();
    }

    triggerGarbageCollector(): Observable<IGarbageCollectorStatistic> {
        return this.http
            .post<Response>(environment.ZONAR_API_URL + `/maintenance/memory`, {})
            .pipe(map(response => this.getData<IGarbageCollectorStatistic>(response)));
    }
}
